import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("userAccessToken");
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const updateBusinessDetails = async (formData) => {
  return axios.post(
    `${API_BASE}/api/business-details/update`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const checkProfileCompletion = async () => {
  return axios.get(
    `${API_BASE}/api/business-details/check-completion`,
    {
      headers: getAuthHeaders(),
    }
  );
};

export const getBusinessDetails = async () => {
  return axios.get(
    `${API_BASE}/api/business-details/get`,
    {
      headers: getAuthHeaders(),
    }
  );
};

